var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import themeGet from '@styled-system/theme-get';
import styledSystemPropTypes from '@styled-system/prop-types';
import { applySizes, applyVariations, color, deprecatedColorValue, borderRadiusAttrs } from '../utils';
import { space, borderRadius, compose } from 'styled-system';
var type = function (props) {
    var badgeColors = {
        blue: {
            backgroundColor: props.theme.colors.blue,
            color: props.theme.colors.white,
        },
        lightBlue: {
            backgroundColor: props.theme.colors.lightBlue,
            color: props.theme.colors.darkBlue,
        },
        green: {
            backgroundColor: props.theme.colors.green,
            color: props.theme.colors.white,
        },
        lightGreen: {
            backgroundColor: props.theme.colors.lightGreen,
            color: props.theme.colors.darkGreen,
        },
        red: {
            backgroundColor: props.theme.colors.red,
            color: props.theme.colors.white,
        },
        lightRed: {
            backgroundColor: props.theme.colors.lightRed,
            color: props.theme.colors.darkRed,
        },
        orange: {
            backgroundColor: props.theme.colors.orange,
            color: props.theme.colors.text,
        },
        gray: {
            backgroundColor: props.theme.colors.gray,
            color: props.theme.colors.white,
        },
        lightGray: {
            backgroundColor: props.theme.colors.lightGray,
            color: props.theme.colors.text,
        },
    };
    return !(props.bg && props.color) && (badgeColors[props.bg] || badgeColors.lightGray);
};
var sizes = {
    small: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n    line-height: ", ";\n  "], ["\n    ", "\n    line-height: ", ";\n  "])), themeGet('textStyles.small'), themeGet('lineHeights.display')),
    medium: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n    line-height: ", ";\n  "], ["\n    ", "\n    line-height: ", ";\n  "])), themeGet('textStyles.display0'), themeGet('lineHeights.standard')),
};
var Badge = styled.div.attrs(borderRadiusAttrs)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: inline-block;\n  text-transform: uppercase;\n  letter-spacing: ", ";\n  ", ";\n  ", ";\n  ", " ", ";\n\n  ", "\n"], ["\n  display: inline-block;\n  text-transform: uppercase;\n  letter-spacing: ", ";\n  ", ";\n  ", ";\n  ", " ", ";\n\n  ", "\n"])), themeGet('letterSpacings.caps'), function (_a) {
    var theme = _a.theme;
    return applySizes(sizes, undefined, theme.mediaQueries);
}, applyVariations('Badge'), type, color, function (props) { return compose(space, borderRadius)(props); });
Badge.displayName = 'Badge';
Badge.propTypes = __assign(__assign({}, styledSystemPropTypes.space), { size: PropTypes.oneOf(Object.keys(sizes)), color: deprecatedColorValue(), bg: deprecatedColorValue(), borderRadius: PropTypes.string });
Badge.defaultProps = {
    size: 'medium',
    px: 2,
    py: 1,
    borderRadius: 'full',
};
export default Badge;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Badge.js.map